module.exports = __webpack_public_path__ + "static/media/施工前.b4649daf.jpg";